import styled from 'styled-components'
import { IconExternalLink } from '@tabler/icons-react'

export const Main = styled.div`
  min-width: 25vw;
  height: 100%;
  background-color: var(--surface-bg);
`
export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem !important;
  margin: 0rem !important;
`

export const CircleIcon = styled.span`
  background: var(--color-warning);
  width: 23px;
  height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-heading);
  border-radius: 50%;
  font-size: 14px;
`

export const SuggestedAppsWithCounter = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`
export const SuggestedAppsTextContainer = styled.span`
  color: var(--color-warning);
  text-decoration: underline;
`

export const SubHeaderContainer = styled.div`
  background: var(--color-warning);
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem !important;
`

export const SubHeaderText = styled.span`
  font-size: ${(props) => (props.fontSize ? props.fontSize : '24px')};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : '34px')};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : '325')};
  margin: ${(props) => (props.marginBoth ? props.marginBoth : '0')};
  color: var(--text-heading);
`

export const SuggestedAppsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem !important;
  color: var(--text-body);
`

export const AppsHeaderContainer = styled.span`
  color: var(--text-disabled);
  font-size: 12px;
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 700;
  line-height: 23px;
  text-transform: uppercase;
  padding-bottom: 1rem;
`

export const AppsRecommendedContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: auto;
  height: 60px;
`

export const ExternalLinkIcon = styled(IconExternalLink)`
  margin-right: 5px;
`

export const AppIconWithNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`

export const AppIcon = styled.div`
  width: 50px;
  height: 50px;
`

export const AppName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 1rem;
  max-width: 14vw;
`

export const ButtonContainer = styled.div`
  width: 144px;
  padding: 16px 0px 16px 8px;
  margin-right: 1.5rem;
`

export const StyledScrollbar = styled.div`
  height: calc(100% - 150px);
  overflow-y: auto;
  overflow-x: hidden;
`
